import { render, staticRenderFns } from "./AssignedEventsTab.vue?vue&type=template&id=c05558a0&scoped=true&"
import script from "./AssignedEventsTab.vue?vue&type=script&lang=js&"
export * from "./AssignedEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05558a0",
  null
  
)

export default component.exports